import { Component } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixComponent } from "../../prefix.component";
import { TemplateNumberComponent } from "../../templates/template-number/template-number.component";
import { Max } from "../../types/Max";
import { Min } from "../../types/Min";

@Component({
  standalone: true,
  selector: "app-prefix-ja2",
  imports: [TemplateNumberComponent],
  templateUrl: "./prefix-ja2.component.html",
  styleUrl: "./prefix-ja2.component.less",
})
export class PrefixJa2Component extends PrefixComponent<string> {
  public min: Min;
  public max: Max;

  public constructor() {
    super({ updateOn: "blur" });
    this.min = 1900;
    this.max = 2500;
    this.required = true;
    this.characters = ALLOWED_CHARACTERS["ja2"];
  }
}
